import Grid from "@/app/(site)/_components/Atoms/Grid"
import CTAGroup from "@/app/(site)/_components/GCSanityModules/ShowcaseModule/CTAGroup"
import { MOBILE_MAX_VIEW_WIDTH, TABLET_MAX_VIEW_WIDTH } from "@/lib/siteconfig/constants"
import { type CTAGroupType } from "@/types/gc-modules-types"

type EmptyCartShowcaseModuleContentProps = {
    ctas: CTAGroupType[]
    isAboveTheFold?: boolean
}

export default function EmptyCartShowcaseModuleContent({
    ctas = [],
    isAboveTheFold = false
}: EmptyCartShowcaseModuleContentProps) {
    const CTAContentStylingClasses = [
        "gap-y-16 gap-x-12",
        "sm:gap-x-16 sm:gap-y-24",
        "md:gap-24",
        "[&_p]:text-[14px]",
        "[&_p]:sm:text-16",
        "[&_.group]:gap-4",
        "sm:[&_.group]:gap-12"
    ]

    const imageSizesCTA = `(max-width: ${MOBILE_MAX_VIEW_WIDTH}px) 50vw, (max-width: ${TABLET_MAX_VIEW_WIDTH}px) 100vw, 25vw`

    return (
        <Grid
            className={CTAContentStylingClasses.join(" ")}
            desktopColumns={4}
            mobileColumns={3}
        >
            {ctas.map((cta, index) => {
                return (
                    <CTAGroup
                        prefetch={false}
                        imageSizes={imageSizesCTA}
                        key={index}
                        CTAGroup={cta}
                        isAboveTheFold={isAboveTheFold}
                    />
                )
            })}
        </Grid>
    )
}
